import { ReactComponent as LensSvgIcon } from "../../assets/icons/lens.svg";
import { ReactComponent as MeasurementIcon } from "../../assets/icons/measurement.svg";
import { ReactComponent as EnvConditionsIcon } from "../../assets/icons/env-conditions.svg";
import { ReactComponent as ReticleIcon } from "../../assets/icons/reticle.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/info.svg";

export function comparisonIconForGroup(group: string) {
  switch (group) {
    case "lens":
      return LensSvgIcon;
    case "measurement":
      return MeasurementIcon;
    case "env. conditions":
      return EnvConditionsIcon;
    // case "digital": return;
    // case "size & weight": return;
    case "reticle":
      return ReticleIcon;
    default:
      return InfoIcon;
  }
}
